import script from "./FormSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSelect.vue?vue&type=script&setup=true&lang=js"

import "./FormSelect.vue?vue&type=style&index=0&id=5ddacfd6&lang=scss&scoped=true"

import exportComponent from "/home/dev/g-nti/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ddacfd6"]])

export default __exports__